import { render } from "./MainPurchaseOrder.vue?vue&type=template&id=2f2c26c1"
import script from "./MainPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./MainPurchaseOrder.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__